class TabComponent extends HTMLElement {
  constructor() {
    super();

    this.tabs = [];
    this.firstTab = null;
    this.lastTab = null;

    this.tabs = [...this.querySelectorAll("[role=tab]")];
    this.tabpanels = new Map();

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      const tabpanel = this.querySelector(
        `#${tab.getAttribute("aria-controls")}`,
      );
      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", "false");
      this.tabpanels.set(tab, tabpanel);

      tab.addEventListener("keydown", this.onKeydown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));
      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    });

    this.currentTab = null;
    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(newTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      setFocus = true;
    }

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (newTab === tab) {
        // new tab
        tab.setAttribute("aria-selected", "true");
        tab.removeAttribute("tabindex");
        this.tabpanels.get(tab).classList.add("tab--active");
        this.querySelector(`[data-secondary-panel="${tab.getAttribute("aria-controls")}"]`)?.classList.add("tab--active");
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.tabIndex = -1;
        this.tabpanels.get(tab).classList.remove("tab--active");
        this.querySelector(`[data-secondary-panel="${tab.getAttribute("aria-controls")}"]`)?.classList.remove("tab--active");
      }
    }

    this.currentTab = newTab;
    this.dispatchEvent(
      new CustomEvent("tab-component:tab-selected", {
        bubbles: true,
        detail: { tab: newTab, panel: this.tabpanels.get(newTab) },
      }),
    );
  }

  setSelectedToPreviousTab(currentTab) {
    var index;
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }
  /* EVENT HANDLERS */
  onKeydown(event) {
    let target = event.currentTarget,
      flag = false;
    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(target);
        flag = true;
        break;
      case "ArrowRight":
        this.setSelectedToNextTab(target);
        flag = true;
        break;
      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;
      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;
      default:
        break;
    }
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

if (!customElements.get("tab-component")) {
  customElements.define("tab-component", TabComponent);
}
